import { render } from "./item_ani.vue?vue&type=template&id=58174c17&ts=true"
import script from "./item_ani.vue?vue&type=script&lang=ts"
export * from "./item_ani.vue?vue&type=script&lang=ts"

import "./item_ani.vue?vue&type=style&index=0&id=58174c17&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__